import { useEffect, useState } from "react";
import { Box, Button, Collapse, List, ListItemButton } from "@mui/material";
import { useAppDispatch, useAppSelector } from "common/hooks";
import { NODE_TYPES } from "common/constants/enums";
import { DragDropContext, Droppable, Draggable } from "@hello-pangea/dnd";
import {
  setNodes,
  setNodeToAdd,
  setNodeToEdit,
  setSectionSummeryGroupId,
} from "store/slices/nodes";
import ConfirmActionPopup from "common/components/ConfirmActionPopup";
import { onDragEnd } from "common/constants/functions";
import { Add } from "@mui/icons-material";
import { DisplayIcon } from "common/components/DisplayIcon";
import VisibilityOffOutlinedIcon from "@mui/icons-material/VisibilityOffOutlined";

const Sidebar = () => {
  const {
    json: { nodes },
    nodeToEdit,
    nodeToAdd,
    sectionSummeryGroupId,
  } = useAppSelector((state) => state.nodes);
  const dispatch = useAppDispatch();
  const [expandedSectionId, setExpandedSectionId] = useState<any>("");
  const [movingElem, setMovingElem] = useState<any>(null);
  const [draggingOverIds, setDraggingOverIds] = useState<any>([]);
  const [currentDraggingOverId, setCurrentDraggingOverId] = useState<any>(null);
  const handleExpandSection = (nodeId: any) => {
    setExpandedSectionId((p: string) => (p === nodeId ? "" : nodeId));
  };

  const handleCloseActionPopup = () => {
    setMovingElem(null);
    setDraggingOverIds([]);
    setCurrentDraggingOverId(null);
  };
  const handleDragEnd = (result: any) => {
    setCurrentDraggingOverId(null);
    setDraggingOverIds([]);
    if (!result) return;
    const { source, destination } = result;
    const isSamePosition =
      !destination || Object.keys(source).every((key) => source[key] === destination[key]);

    if (isSamePosition) return;
    setMovingElem(result);
  };
  useEffect(() => {
    const expnadSectionOnDragOver = setTimeout(() => {
      if (currentDraggingOverId && !draggingOverIds.includes(currentDraggingOverId)) {
        setDraggingOverIds((p: any) => [...p, currentDraggingOverId]);
      }
    }, 500);
    return () => clearTimeout(expnadSectionOnDragOver);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentDraggingOverId]);
  return (
    <div className="sidebar">
      <img src={require("assets/img/logo.png")} alt="" style={{ width: 150 }} />
      <div>
        <DragDropContext onDragEnd={handleDragEnd}>
          <Droppable droppableId="droppable-list" type="parent">
            {(droppableProvided) => (
              <List
                {...droppableProvided.droppableProps}
                ref={droppableProvided.innerRef}
                sx={{ mx: "-10px" }}
              >
                {nodes
                  ?.filter((n: any) => n?.parentNode === "")
                  ?.map((node: any, index: number) => (
                    <Draggable key={node.id} draggableId={String(node.id)} index={index}>
                      {(draggableProvided) => (
                        <ListItemButton
                          onClick={() => dispatch(setNodeToEdit(node))}
                          sx={{
                            p: 0,
                            pb: 1,
                            borderRadius: 1,
                            color: "#fff",
                            backgroundColor:
                              nodeToEdit?.id === node?.id ? "#1976d233 !important" : "",
                            display: "block",
                            background: currentDraggingOverId === node?.id ? "#ffffff10" : "",
                          }}
                          ref={draggableProvided.innerRef}
                          {...draggableProvided.draggableProps}
                          {...draggableProvided.dragHandleProps}
                          style={{
                            ...draggableProvided.draggableProps.style,
                          }}
                        >
                          <Droppable droppableId={String(node?.id)} type="child">
                            {(droppableProvidedLevel2) => {
                              return (
                                <Box
                                  {...droppableProvidedLevel2.droppableProps}
                                  ref={droppableProvidedLevel2.innerRef}
                                >
                                  <Box sx={{ display: "flex", alignItems: "center" }}>
                                    <span
                                      onClick={() => handleExpandSection(node?.id)}
                                      style={{
                                        color: expandedSectionId === node?.id ? "#fff" : "",
                                        display: "flex",
                                        gap: 10,
                                        alignItems: "center",
                                        padding: "10px ",
                                      }}
                                    >
                                      {node?.data?.icon && <DisplayIcon icon={node?.data?.icon} />}
                                      {node?.data?.properties?.title?.ifValue ||
                                        node?.data?.properties?.title?.elseValue}
                                    </span>
                                    {!node?.data?.visibility?.condition && (
                                      <VisibilityOffOutlinedIcon
                                        sx={{
                                          ml: 1,
                                          fontSize: "14px",
                                          color: "#d32f2f",
                                        }}
                                      />
                                    )}
                                  </Box>

                                  <Collapse
                                    in={
                                      expandedSectionId === node?.id ||
                                      draggingOverIds.includes(node?.id) ||
                                      true
                                    }
                                  >
                                    <List sx={{ pl: 4 }}>
                                      {nodes
                                        ?.filter((n: any) => n?.parentNode === node?.id)
                                        ?.map((n: any, i: number) => (
                                          <Draggable
                                            key={n.id}
                                            draggableId={String(n.id)}
                                            index={i}
                                          >
                                            {(draggableProvidedLevel2, snapshot) => {
                                              snapshot?.draggingOver &&
                                                setCurrentDraggingOverId(snapshot?.draggingOver);
                                              return (
                                                <ListItemButton
                                                  onMouseDown={(e) => e.stopPropagation()}
                                                  onClick={(e) => {
                                                    e.stopPropagation();
                                                    dispatch(setNodeToEdit(n));
                                                    dispatch(setSectionSummeryGroupId(n?.id));
                                                  }}
                                                  sx={{
                                                    justifyContent: "space-between",
                                                    padding: "10px",
                                                    borderRadius: 1,
                                                    backgroundColor:
                                                      nodeToEdit?.id === n?.id
                                                        ? "#1976d233 !important"
                                                        : "",
                                                  }}
                                                  key={n?.id}
                                                  {...draggableProvidedLevel2.draggableProps}
                                                  {...draggableProvidedLevel2.dragHandleProps}
                                                  ref={draggableProvidedLevel2.innerRef}
                                                  style={{
                                                    ...draggableProvidedLevel2.draggableProps.style,
                                                  }}
                                                >
                                                  <span
                                                    style={{
                                                      color:
                                                        sectionSummeryGroupId === n?.id
                                                          ? "#fff"
                                                          : "",
                                                    }}
                                                  >
                                                    {n?.data?.properties?.title?.ifValue ||
                                                      n?.data?.properties?.title?.elseValue}
                                                  </span>
                                                  {!n?.data?.visibility?.condition && (
                                                    <VisibilityOffOutlinedIcon
                                                      sx={{
                                                        ml: 1,
                                                        fontSize: "14px",
                                                        color: "#d32f2f",
                                                      }}
                                                    />
                                                  )}
                                                </ListItemButton>
                                              );
                                            }}
                                          </Draggable>
                                        ))}

                                      {droppableProvidedLevel2.placeholder}
                                    </List>
                                    <Box sx={{ pl: 4 }}>
                                      <Button
                                        variant={
                                          nodeToAdd?.parentNode === node?.id
                                            ? "contained"
                                            : "outlined"
                                        }
                                        size="small"
                                        sx={{ fontSize: 12 }}
                                        onMouseDown={(e) => e.stopPropagation()}
                                        onClick={(e) => {
                                          e.stopPropagation();
                                          dispatch(
                                            setNodeToAdd({
                                              nodeType: NODE_TYPES.sectionsummarygroup,
                                              parentNode: node?.id,
                                            })
                                          );
                                        }}
                                      >
                                        <Add sx={{ mr: 0.5 }} /> Section Summary Group
                                      </Button>
                                    </Box>
                                  </Collapse>
                                </Box>
                              );
                            }}
                          </Droppable>
                        </ListItemButton>
                      )}
                    </Draggable>
                  ))}

                {droppableProvided.placeholder}
              </List>
            )}
          </Droppable>
          <Box sx={{ px: 0 }}>
            <Button
              variant={nodeToAdd?.parentNode === "" ? "contained" : "outlined"}
              size="small"
              sx={{ fontSize: 12 }}
              onMouseDown={(e) => e.stopPropagation()}
              onClick={(e) => {
                e.stopPropagation();
                dispatch(setNodeToAdd({ nodeType: NODE_TYPES.section, parentNode: "" }));
              }}
            >
              <Add sx={{ mr: 0.5 }} /> Section
            </Button>
          </Box>
        </DragDropContext>
      </div>
      <ConfirmActionPopup
        {...{
          open: !!movingElem,
          onClose: handleCloseActionPopup,
          onConfirm: () =>
            onDragEnd({ movingElem, handleCloseActionPopup, nodes, dispatch, setNodes }),
          text: "move",
        }}
      />
    </div>
  );
};

export default Sidebar;
